// extracted by mini-css-extract-plugin
export var emailBlockLink = "_i3-0";